@if (isSpinner$()) {
  <sol-spinner size="auto" />
} @else {
  <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24">
    <use [attr.href]="href$()" />
  </svg>
}
